import React, { useEffect, useContext, useState } from 'react';
import { ModalContext } from 'commons-ui';

import usePayInDetails from './usePayInDetails';
import { SelectFilterContent } from './selectFilter';

const useFilter = () => {
	const { getPayInData, handleFilterSubmit, forceUpdate, showLoader } = usePayInDetails();
	const [changeFilter, setChangeFilter] = useState(false);
	const { setModalConfig } = useContext(ModalContext);

	const handleFilterFormClose = () => {
		setModalConfig({ isOpen: false });
		setChangeFilter(false);
	};

	const handleFilterModalOpen = () => {
		setModalConfig({
			isOpen: true,
			header: 'Enter PayIn Details Filter',
			content: <SelectFilterContent handleFilterSubmit={handleFilterSubmit} onClose={handleFilterFormClose} />
		});
	};

	useEffect(() => {
		if (changeFilter) {
			handleFilterModalOpen();
		}
	}, [changeFilter]);

	useEffect(() => {
		handleFilterModalOpen();
	}, []);

	return {
		getPayInData,
		forceUpdate,
		showLoader,
		setChangeFilter
	};
};

export default useFilter;
